<template>
    <div id="post-block-group" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row block-header mob-just">
            <h3 class="block-title p-0 ml-0 mr-0" :style="blockTitleCss">
                <span :style="blockTitleSpanCss" :class="this.color && this.color.replace('#', 'css_')">{{title}}</span>
            </h3>
        </div>
        <div class="row slot-cont">
            <slot :color="color"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PostBlockGroup',
        props: ['title', 'color'],
        data() {
            return {

            }
        },
        components: {

        },
        computed: {
            blockTitleCss() {
                return {
                    'border-bottom': '2px '+this.color+' solid',
                }
            },
            blockTitleSpanCss() {
                return {
                    'background-color': this.color,
                    'border-color': '2px '+this.color+' solid',
                }
            },
        },
        mounted() {
            if(this.color) {
                //$('.block-title').css('border-bottom', this.color);
                //$('.block-title span').css('background-color', this.color);
                //$('.block-title span').after().css('border-color', this.color+' rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0)');
            }
        }
    }
</script>

<style lang="scss" scoped>
    #post-block-group {
        position: relative;
        /*transform: translate3d(-15px, 0px, 0px);*/
        transition: all 0.25s ease 0s;
        padding: 0px;
        margin: 15px 0px;

        .block-header {
            width: 100%;
            margin-left: 0px;
            margin-right: 0px;
        }

        @media (max-width: 576px) {
            width: auto !important;

            .post-thumb {
                img {
                   height: 185px;
                    object-fit: cover;
                }
            }

            .home-block-g {
                .block-header {
                    width: 109% !important;
                    margin-left: 0px !important;
                    margin-right: 0px !important;
                }
            }
        }

        .block-title {
            border-bottom: 2px solid #ec0000;
            font-size: 14px;
            line-height: 100%;
            margin: 0 15px 40px;
            padding-left: 0px;
            text-transform: uppercase;
            width: 100%;

            span {
                background: #ec0000;
                color: #fff;
                height: 30px;
                line-height: 30px;
                padding: 8px 15px;
                position: relative;
            }

            span:after {
                border-color: #ec0000 rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);
                position: absolute;
                content: " ";
                width: auto;
                height: auto;
                bottom: -20px;
                margin-left: -10px;
                left: 50%;
                border-width: 10px;
                border-style: solid;
            }
        }
    }
</style>
